(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('UsoMaquinasService', UsoMaquinasService);

  UsoMaquinasService.$inject = [
    'RestService'
  ];

  function UsoMaquinasService(RestService) {
    return {
      load
    };

    function load(params) {
      params.page = params.page || 1;
      return RestService.getFromUrl(`${SERVER}v1/prestacao_servicos`, params);
    }
  }
}());
